'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMInputField = require('../OMInputField/OMInputField');var _OMInputField2 = _interopRequireDefault(_OMInputField);
var _OMFormGroup = require('./OMFormGroup.scss');var _OMFormGroup2 = _interopRequireDefault(_OMFormGroup);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMFormGroup = function OMFormGroup(properties) {var _cx, _cx2;var
  label =
  properties.label,isRequired = properties.isRequired,name = properties.name,onChange = properties.onChange,tooltipMessage = properties.tooltipMessage,title = properties.title,value = properties.value,error = properties.error,isMobile = properties.isMobile,touched = properties.touched,readOnly = properties.readOnly,isAccordion = properties.isAccordion,onBlur = properties.onBlur,onKeyDown = properties.onKeyDown,isRtl = properties.isRtl,className = properties.className,classNameLabel = properties.classNameLabel;
  return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(_OMFormGroup2.default.groupWrapper, className, (_cx = {}, _cx[_OMFormGroup2.default.accordionWrapper] = isAccordion, _cx)) },
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_OMFormGroup2.default.label, classNameLabel) },
        label, ' ', isRequired && _react2.default.createElement('span', { className: 'req' }, '*')),

      _react2.default.createElement('div', { className: (0, _classnames2.default)(_OMFormGroup2.default.field, (_cx2 = {}, _cx2[_OMFormGroup2.default.accordion] = isAccordion, _cx2)) },
        _react2.default.createElement(_OMInputField2.default, {
          type: 'text',
          placeholder: label,
          name: name,
          onChange: onChange,
          tooltipMessage: tooltipMessage,
          title: title || label,
          showHoverTooltip: !!error,
          isInvalid: !!error && touched,
          value: value,
          validate: function validate(val) {return isRequired ? !!val : true;},
          isMobile: isMobile,
          readOnly: readOnly,
          onBlur: onBlur,
          onKeyDown: onKeyDown,
          isRtl: isRtl }))));




};exports.default =

OMFormGroup;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMFormGroup/OMFormGroup.js
// module id = 2743
// module chunks = 0